import BulkImportTypes from '../components/atoms/bulkImport/bulkImportTypes';
import { ButtonTheme } from '../components/atoms/button/button';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import routes from '../routes/route';
import tableSportRoomContentsVT from './tableSportRoomContentsVT';

export default {
  attributeName: 'config',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  bulkSelectable:true,
  bulkButtons:[
      {label:"Import config",
        color:ButtonTheme.INFO,
        action:"bulkImport",
        actionUrl:"appConfig/bulkImport",
        type:BulkImportTypes.SPORTROOMCONFIG,
        title:"Import elements",
        showNumberElems:false,
        sessionParams: ['appId'],
        formConfig:[
          {
            attributeName: 'type',
            helpText: 'Type of import',
            type: FormInputTypes.TEXT_INPUT.TEXT,
            required: true,
            label: 'Type',
            defaultValue:BulkImportTypes.SPORTROOMCONFIG,
            hidden:true
          },
          {
            attributeName: 'config',
            helpText: 'Select a valid config for the app selected, or set All for all the possible configs of the app',
            type: FormInputTypes.SELECT,
            label: 'Config',
            placeholder: 'Please enter to add a valid config',
            multiple: false,
            disabledWhenEdit:true,
            url: 'appConfigslist/appId?type=list',
            enabledWhen:{"field":"app","notValues":['(Empty)']},
            emptyValue:true,
            default:'(Empty)', //default value to empty option
            allValue:'(All)',
            fieldValue:'id',
            fieldName:'name',
            asyncSelect: true,
            options:[],
            session: ['appId'],
          },
          {
            attributeName: 'canvasOverride',
            helpText: 'Override the canvas into the imported config',
            type: FormInputTypes.CHECKBOX,
            required: false,
            label: 'Override Canvas',
            hidden: true,
          },
          {
            attributeName: 'canvasOverrideText',
            helpText: 'Override the canvas into the imported config',
            type: FormInputTypes.TEXT,
            disabled:true,
            required: true,
            default:"ATTENTION! Checking the 'Override' checkbox will delete the existing canvas and replace it with the canvas from the ZIP file.",
            label: 'Override Canvas',
            hidden: true,
          },
          {
            attributeName: 'composeExperienceCreation',
            helpText: 'Always generate compose experience',
            type: FormInputTypes.CHECKBOX,
            required: true,
            label: 'Duplicate Composed experiences if exist',
          },
          {
            attributeName: 'composeExperienceCreationText',
            helpText: 'Generate compose experience',
            type: FormInputTypes.TEXT,
            disabled:true,
            required: true,
            default:"ATTENTION! If checked, we will create different composed experiences for the new pasted contents.",
            label: 'Compose experience creation',
          },
        ]
      },
      {label:"Export",
        color:ButtonTheme.INFO,
        action:"bulkExport",
        title:"Export records",
        type:BulkImportTypes.SPORTROOMCONFIG,
        showNumberElems:true,
        disabled:'no-selection',
        hidden:'no-selection'
      }],
  isMultiSelectable:true,
  maxSelections:1,

  emptyMessage: "You don't have configs defined yet. To create configs, go to Main page-> Xtadium -> Config section",
  fields: [
    {
      attributeName: 'id',
      label: 'Id',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'AppId of this config.',
      default: '',
      width: '15rem',
      canEdit: false,
      canCreate: false,
      canFilter: false,
      canOrder: false,
      exactWidth:'100px'
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of the config.',
      default: '',
      width: '15rem',
      canEdit: true,
      canCreate: true,
      canFilter: true,
      canOrder: true,
    },
    {
      attributeName: 'totalContents',
      label: 'Total contents',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Total number of contents in this config.',
      default: '',
      width: '15rem',
      canEdit: false,
      canCreate: false,
      canFilter: false,
      canOrder: false,
      exactWidth:'150px'
    },
    {
      attributeName: 'hasCanvas',
      helpText: 'If the config has canvas created',
      label: 'Has canvas',
      default: true,
      type: FormInputTypes.CHECKBOX,
      canEdit: false,
      canCreate: false,
      exactWidth:'150px'
    },
    
  ],
};
